import React from 'react';
import {LINKS, PAGES} from '../constants';
import {connect} from "react-redux";
import Selectors from "../selectors";
import {updateCurrentPageAction, updateGtmRegistrationSuccessSentAction} from "../state/registration";
import {putDataIntoDataLayer, invalidateBtagCookie, invalidatePromocodeCookie} from "../utils";

const stateToProps = (state) => ({
  isDesktop: Selectors.isDesktop(state),
  emailData: Selectors.getEmailData(state),
  createAccountMessageError: Selectors.getCreateAccountMessageError(state),
  createAccountSuccess: Selectors.createAccountSuccess(state),
  clientId: Selectors.getClientId(state),
  gtmRegistrationSuccessSent: Selectors.getGtmRegistrationSuccessSent(state),
});

const actionsToProps = (dispatch) => ({
  updateCurrentPage: (data) => dispatch(updateCurrentPageAction(data)),
  updateGtmRegistrationSuccessSent: (data) => dispatch(updateGtmRegistrationSuccessSentAction(data)),
});

const useComponentDidMount = onMountHandler => {
  React.useEffect(() => {
    onMountHandler();
  }, []);
};

const CompletedStep = props =>  {

  useComponentDidMount(() => {
    window.scrollTo({top: 0, behavior: 'smooth'});

    if (props.createAccountSuccess) {
        invalidateBtagCookie();
        invalidatePromocodeCookie();
    }

    if (props.createAccountSuccess === true && props.clientId != null && props.gtmRegistrationSuccessSent === false) {
      putDataIntoDataLayer({
        event: `registrationSuccess`,
        platform: props.isDesktop === true ? 'desktop' : 'mobile',
        user_id: props.clientId,
      });

      props.updateGtmRegistrationSuccessSent();
    }
  });

  const renderSuccess = () => {
    return (
      <div className="registration-main">
        <div className="registration-main__head txt-c">
          <h1 className="registration-main__h1">Welcome to Bet9ja</h1>
          <h2 className="registration-main__h2">Start using your account right away!</h2>
          <button
              className="btn-primary-s registration-form__submit"
              type="button"
              onClick={() => {
                if (props.isDesktop) {
                  window.open(LINKS.deposit, '_blank', 'width=1000,height=600');
                } else {
                  window.location = LINKS.deposit_mobile;
                }
              }}
              title="Make a Deposit"
          >
            Make a Deposit
          </button>
          <div className="registration-main__or-txt mt20 mb10">or</div>
          <div>
            <a className="registration__link" href={LINKS.home} title="Continue">continue</a>
          </div>
        </div>
        <div className="separator" />
        <div className="registration__summary">
          <div className="registration__callout-alert txt-c">
            <p className="registration__intro mb10">
              We have sent an email to:
              {' '}
              {props.emailData.value}
            </p>
            <p className="registration__intro">
              <b>You need to verify your email before you can withdraw any funds.</b>
            </p>
            <i className="registration__callout-alert-i icon-mail" />
          </div>
          <div className="registration__summary-instruct">
            <p className="registration__intro-h3">
              <b>{'Can\'t find our email?'}</b>
            </p>
            <p className="registration__intro-h3 mb20">{'We\'ll send the email from "Bet9ja," so you can quickly search for it.'}</p>
            <p className="registration__intro-h3 mb20">
              Entered a wrong email address when registering? You can
              <a className="registration__link mr5 ml5" href={LINKS.contact_us} title="contact us">contact us</a>
              to update it.
            </p>
            <p className="registration__intro-h3">
              <b>Contact Us</b>
            </p>
            <p className="registration__intro-h3 mb20">
              If you have tried the steps above and still cant find your registration email you can
              <a className="registration__link ml5" href={LINKS.contact_us} title="Contact our customer service">contact our customer service</a>
              .
            </p>
          </div>
        </div>
      </div>
    );
  };

  const renderError = () => {
    return (
        <div className="registration-main">
          <div className="registration__summary registration__summary--error">
            <div className="registration__callout-alert txt-c">
              <p className="registration__head-h1">There was a problem with registration</p>
              {props.createAccountMessageError && (
                  <p className="registration__head-h2 mt15">{props.createAccountMessageError}</p>
              )}
              <p className="registration__head-h2 mt15">
                We were unable to create your account at this time. You can
                <a className="registration__link mr5 ml5" href={LINKS.contact_us} title="Contact customer service">contact</a>
                customer service
              </p>
              <button onClick={() => { props.updateCurrentPage(PAGES.FIRST_STEP); }} className="btn-primary-s registration-form__submit" type="button" title="Submit Form Again">Submit Form Again</button>
            </div>
          </div>
        </div>
    );
  };

  if (props.createAccountSuccess === true) {
    return renderSuccess();
  } else {
    return renderError();
  }
}

export default connect(
    stateToProps,
    actionsToProps
)(CompletedStep);
